import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { PagamentoService, AcordoService } from '../../../services';

@Component({
    templateUrl: 'pagamento.edit.component.html',
})

export class PagamentoEditComponent extends DetalheBaseController {

    model: any = {};
    showMsgAdd: boolean = false;
    showBandeira: number = 0;
    maxCharCartao: number = 16;
    minCharCartao: number = 0;
    maxCS: number = 0;
    isReadOnly: boolean = false;
    isLoaded: boolean = false;
    acordoId: number;  
    acordo: any = {};  
    rotacionarCartao: boolean = false;

    _cartaoNumero: string = "XXXXXXXXXXXXXXXX";
    _cartaoNome: string = "XXXXXX XXXXXX";
    _cartaoMes: string = "XX";
    _cartaoAno: string = "XX";
    _cartaoCVV: string = "XXX";
    imagePath: string = "";
    showCartao: boolean = false;
    imageCard: string = "";

    constructor(route: ActivatedRoute, private _pagamentoService: PagamentoService, private _acordoService: AcordoService) {
        super(route, _pagamentoService);                
    }

    ngOnInit() {        
        this.acordoId = this._route.snapshot.params['id'];        
        this.getAcordo();
        this.showForm = true;
    }

    public salvar(form) { 
        let type = this._route.snapshot.data['type'];
        if (type == "add") {            
            this._dialog.confirm('Pagamento', 'Realizar o pagamento?', () => {    
                this._loading.carregar();
                form.operadora = 1;                
                form.parcelaId = this.acordo.parcelasAtivas[this.model.parcelasPagar - 1].listParcelaId;
                form.valor = this.acordo.parcelasAtivas[this.model.parcelasPagar - 1].valorTotal;
                form.parcelas = this.model.parcelasPagar;
                form.bandeira = this.showBandeira;
                form.dataExpiracao = form.dataValidade.substring(0, 2) + '/20' + form.dataValidade.substring(2, 6);
                this.subPost = this.service.post(this.service._api + "Pagar", form).subscribe(result => {
                    if (result.codigoTransacao != null && result.codigoTransacao != "") {                    
                        localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.pagamentoComSucesso") + '!');
                        this._location.back();    
                    } else {
                        this._notificationsService.Erro("Erro no Pagamento", "Código: " + result.codigoRetorno + " - " + result.mensagemRetorno);
                    }
                    this._loading.fecharTodos();
                },
                error => {
                    this._loading.fecharTodos();
                    this._notificationsService.Erro("Erro no Pagamento", this.translate.instant("controllerBase.erroPagamento") + " Erro: " + error.statusText);
                });
            });
        }
    }

    getAcordo() {
        this._loading.carregar();        
        this._acordoService.getAcordoPorId(this.acordoId).subscribe(result => {            
            this._loading.fecharTodos();
            this.acordo = result;              
            this.acordo.numeroDivida = 1;
            this.acordo.parcelasAtivas = this.obterQtdeParcelasAtivas(this.acordo);
            this.showForm = true;                        
        });    
    }

    obterQtdeParcelasAtivas(divida) {                        
        let qtde = 0;        
        let parcelas = [];         
        let ids = '';
        let qtdeTotal = divida.acordoParcelas.length;
        let idx = 1;
        let total = 0;
        
        divida.acordoParcelas.forEach(element => {                        
            if (element.numeroParcela >= divida.parcelaAtual && divida.parcelaAtual != 0) {                
                qtde++;
                ids += element.id;
                total += element.valor;
                parcelas.push({ index: qtde, checked: (idx >= qtdeTotal ? true : false), listParcelaId: ids, valor: element.valor, valorTotal: total });                
                ids += ',';
            }     
            idx++;       
        });                    

        this.model.parcelasPagar = qtde;
        return parcelas;
    }

    totalPagar(qtdeParcelas) {
        if (qtdeParcelas == undefined || this.acordo == undefined) return 1;
        let total = 0;
        let idx = 1;               
        this.acordo.parcelasAtivas.forEach(element => {                        
            if (idx <= qtdeParcelas)            
                total += element.valor;
            idx++;
        });          
        
        return total;
    }

    FlipCard(value) {         
        if (value == "front")
            this.rotacionarCartao = false;
        else
            this.rotacionarCartao = true;
    }

    validDate(dValue, form) 
    {
        var result = false;
        var originalValue = dValue;
        dValue = dValue.substr(0,2) + "/" + dValue.substr(2,2);
        dValue = dValue.split('/');
        var pattern = /^\d{2}$/;
      
        if (dValue[0] < 1 || dValue[0] > 12)
            result = true;
      
        if (!pattern.test(dValue[0]) || !pattern.test(dValue[1]))
            result = true;
      
        if (dValue[2])
            result = true;
      
        if (result) 
            form.controls["dataValidade"].setErrors({'incorrect': true});
        
        this._cartaoMes = originalValue == "" ? "XX" : originalValue.substring(0,2);
        if (originalValue.length > 2)
            this._cartaoAno = originalValue == "" ? "XX" : originalValue.substring(2,4);
        else
            this._cartaoAno = "XX";
      }

    QualOperadora(cardNumber, form)
    {
        var visaRegex = /^(4)/;
        var masterRegex = /^(51|52|53|54|55)/;
        var amexRegex = /^(34|37)/;
        var eloRegex = /^(636368|636369|438935|504175|451416|636297|5067|4576|4011|506699)/;
        var auraRegex = /^(50)/;  
        var jcbRegex = /^(35[2-9][8-9]|35[0-8][0-9])/;
        var dinersRegex = /^(300|301|302|303|304|305|36)/;
        var discoverRegex = /^(6011|622|644|645|646|647|648|649|65)/;
        var hipercardRegex = /^(38|60)/;        
        
        if (visaRegex.test(cardNumber)) { // Visa
            this.showBandeira = 1; this.maxCharCartao = 16; 
            this.minCharCartao = 13; this.maxCS = 3;
            this.imagePath = "../assets/images/ccvisa_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccvisa.png";
        } else if (masterRegex.test(cardNumber)) { // MasterCard
            this.showBandeira = 2; this.maxCharCartao = 19; 
            this.minCharCartao = 16; this.maxCS = 3;            
            this.imagePath = "../assets/images/ccmaster_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccmaster.png";
        } else if (amexRegex.test(cardNumber)) { // Amex
            this.showBandeira = 3; this.maxCharCartao = 15; 
            this.minCharCartao = 15; this.maxCS = 4;
            this.imagePath = "../assets/images/ccamex_61x38.png";
            this.showCartao = true;
            this.imageCard = "../assets/images/ccamex.png";
        } else if (eloRegex.test(cardNumber)) { // Elo
            this.showBandeira = 4; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccelo_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (auraRegex.test(cardNumber)) { // Aura
            this.showBandeira = 5; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccaura_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (jcbRegex.test(cardNumber)) { // JCB
            this.showBandeira = 6; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 3;
            this.imagePath = "../assets/images/ccjcb_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (dinersRegex.test(cardNumber)) { // Diners
            this.showBandeira = 7; this.maxCharCartao = 14; 
            this.minCharCartao = 14; this.maxCS = 3;
            this.imagePath = "../assets/images/ccdiners_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (discoverRegex.test(cardNumber)) { // Discover
            this.showBandeira = 8; this.maxCharCartao = 16; 
            this.minCharCartao = 16; this.maxCS = 4;
            this.imagePath = "../assets/images/ccdiscover_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else if (hipercardRegex.test(cardNumber)) { // Hipercard
            this.showBandeira = 9; this.maxCharCartao = 19; 
            this.minCharCartao = 13; this.maxCS = 4;
            this.imagePath = "../assets/images/cchiper_61x38.png";
            this.showCartao = false; this.imageCard = "";
        } else {
            this.showBandeira = 0; this.maxCharCartao = 16; 
            this.minCharCartao = 13; this.maxCS = 3;
            form.controls["numero"].setErrors({'incorrect': true});
            this.imagePath = ""; this.showCartao = false; this.imageCard = "";
        }

        this._cartaoNumero = (cardNumber == "" || cardNumber == undefined) ? "XXXXXXXXXXXXXXXX" : cardNumber;
    }

    changeNome() {        
        this._cartaoNome = (this.model.nome == "" || this.model.nome == undefined) ? "XXXXXX XXXXXX" : this.model.nome;
    }

    changeCVV() {
        this._cartaoCVV = (this.model.codigoSeguranca == "" || this.model.codigoSeguranca == undefined) ? "XXX" : this.model.codigoSeguranca;
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/pagamento/edit/pagamento.edit.component.ts